import React, { Suspense, lazy, useEffect } from "react";
import { scrollToSection } from "../utils/scrollToSection";
import LazyHomeSection from "./ui/lazy-home-section";
import {
  HeroSkeleton,
  CardsSectionSkeleton,
  WhyPycraySectionSkeleton,
  TestimonialsSectionSkeleton,
  CommunitySectionSkeleton,
  CtaSectionSkeleton,
  LogosSectionSkeleton,
} from "./ui/skeleton";

const HomeHero = lazy(() => import("./pages/homepage/hero"));
const ClientLogos = lazy(() => import("./pages/homepage/client-logos"));
const WhatWeBuild = lazy(() => import("./pages/homepage/what-we-build"));
const DeliveredProjects = lazy(() =>
  import("./pages/homepage/delivered-projects")
);
const HowWeWork = lazy(() => import("./pages/homepage/how-we-work"));
const WhyPycray = lazy(() => import("./pages/homepage/why-pycray"));
const HomeTestimonials = lazy(() => import("./pages/homepage/testimonials"));
const InTheCommunity = lazy(() => import("./pages/homepage/in-the-community"));
const FinalCta = lazy(() => import("./pages/homepage/final-cta"));

export const Home = () => {
  useEffect(() => {
    const section = sessionStorage.getItem("scrollTo");
    if (section) {
      sessionStorage.removeItem("scrollTo");
      setTimeout(() => scrollToSection(section), 400);
    }
  }, []);

  return (
    <div id="homepage">
      <main className="flex flex-col">
        <Suspense fallback={<HeroSkeleton />}>
          <HomeHero />
        </Suspense>

        <LazyHomeSection fallback={<LogosSectionSkeleton />}>
          <Suspense fallback={<LogosSectionSkeleton />}>
            <ClientLogos />
          </Suspense>
        </LazyHomeSection>

        <LazyHomeSection fallback={<CardsSectionSkeleton columns={2} cards={2} />}>
          <Suspense fallback={<CardsSectionSkeleton columns={2} cards={2} />}>
            <WhatWeBuild />
          </Suspense>
        </LazyHomeSection>

        <LazyHomeSection fallback={<CardsSectionSkeleton columns={1} cards={1} />}>
          <Suspense fallback={<CardsSectionSkeleton columns={1} cards={1} />}>
            <DeliveredProjects />
          </Suspense>
        </LazyHomeSection>

        <LazyHomeSection fallback={<CardsSectionSkeleton columns={3} cards={3} />}>
          <Suspense fallback={<CardsSectionSkeleton columns={3} cards={3} />}>
            <HowWeWork />
          </Suspense>
        </LazyHomeSection>

        <LazyHomeSection fallback={<WhyPycraySectionSkeleton />}>
          <Suspense fallback={<WhyPycraySectionSkeleton />}>
            <WhyPycray />
          </Suspense>
        </LazyHomeSection>

        <LazyHomeSection fallback={<TestimonialsSectionSkeleton />}>
          <Suspense fallback={<TestimonialsSectionSkeleton />}>
            <HomeTestimonials />
          </Suspense>
        </LazyHomeSection>

        <LazyHomeSection fallback={<CommunitySectionSkeleton />}>
          <Suspense fallback={<CommunitySectionSkeleton />}>
            <InTheCommunity />
          </Suspense>
        </LazyHomeSection>

        <LazyHomeSection fallback={<CtaSectionSkeleton />}>
          <Suspense fallback={<CtaSectionSkeleton />}>
            <FinalCta />
          </Suspense>
        </LazyHomeSection>
      </main>
    </div>
  );
};
